import styled from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'

export const StyledNewBlankSection = styled.div`
    padding: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 3}px 0px;
    border-top: 1px solid ${({ theme }) => theme.color.border.default};
    &:first-child {
        border-top: 0 none;
    }
    &:last-child {
        border-bottom: 1px solid ${({ theme }) => theme.color.border.default};
    }
`
